import { defineStore } from 'pinia';

export default defineStore('modalStore', {
    state: () => ({
        isActive: false,
    }),
    actions: {
        toggle() {
            this.isActive = !this.isActive;
        },
        close() {
            this.isActive = false;
            document.removeEventListener('keyup', this.escapeKeyEvent)
            return this.isActive;
        },
        open() {
            this.isActive = true;
            document.addEventListener('keyup', this.escapeKeyEvent);
            return this.isActive;
        },

        escapeKeyEvent(event) {
            if(event.key === "Escape") {
                this.isActive = false;
            }
        }
    },
});
